export default "__VITE_ASSET__BKXeJ81T__"